function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1058_2790)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.4353 40H3.43532V20H18.4353V40ZM18.4353 10H0.10199V16.6667H18.4353V10ZM21.7687 40H36.7687V20H21.7687V40ZM21.7687 10V16.6667H40.102V10H21.7687ZM29.0503 0C24.1387 0 21.2653 5.795 20.102 8.33333H29.0103C34.832 8.33333 34.8937 0 29.0503 0ZM27.7237 6.035H24.3187C25.5503 4.16667 26.717 2.75833 28.222 2.75833C30.1753 2.75833 30.2687 6.035 27.7237 6.035ZM11.1937 8.33333H20.102C18.9387 5.795 16.0653 0 11.1537 0C5.31032 0 5.37199 8.33333 11.1937 8.33333ZM11.982 2.75833C13.487 2.75833 14.6537 4.16667 15.8853 6.035H12.4803C9.93532 6.035 10.0287 2.75833 11.982 2.75833Z",
  fill: "url(#paint0_linear_1058_2790)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1058_2790",
  x1: 0.10199,
  y1: 20,
  x2: 40.1015,
  y2: 19.865,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1D4ED8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A855F7"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1058_2790"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white",
  transform: "translate(0.10199)"
})));

function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.55044db0ba2ca4ef399218cc3f7111de.svg";
export { ForwardRef as ReactComponent };